import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import NewsCard from "@/components/NewsCard";
import WorldCupModule from "@/components/WorldCupModule";
import HomeWorldCupResults from "@/components/HomeWorldCupResults";
import { api } from "@/lib/api";

export default function CategoryPage() {
  const { slug } = useParams();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState(null);

  useEffect(() => {
    setLoading(true);
    Promise.all([
      api.get("/articles", { params: { category: slug, limit: 50 } }),
      api.get("/categories"),
    ]).then(([artsR, catsR]) => {
      setItems(artsR.data.items || []);
      const found = (catsR.data || []).find((c) => c.slug === slug);
      setCategory(found);
    }).finally(() => setLoading(false));
  }, [slug]);

  const isDeportes = slug === "deportes";

  return (
    <>
      <Header />
      <main className="max-w-[1440px] mx-auto px-4 md:px-8 py-10" data-testid="category-page">
        <div className="border-b pb-6 mb-8" style={{ borderColor: "var(--border)" }}>
          <p className="overline accent-text mb-2">CATEGORÍA</p>
          <h1 className="font-headline uppercase text-4xl md:text-6xl" data-testid="category-title">
            {category?.name || slug}
          </h1>
          <p className="mt-3 text-sm" style={{ color: "var(--text-muted)" }}>
            {items.length} {items.length === 1 ? "nota" : "notas"} publicadas
          </p>
        </div>

        {isDeportes && (
          <div className="mb-10">
            <HomeWorldCupResults />
          </div>
        )}

        {isDeportes && <WorldCupModule articles={items} />}

        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {Array(8).fill(0).map((_, i) => (
              <div key={i} className="aspect-[4/3] bg-[color:var(--surface-2)] rounded-sm animate-pulse" />
            ))}
          </div>
        ) : items.length === 0 ? (
          <div className="text-center py-20">
            <p className="font-headline text-2xl mb-2">Aún no hay notas en esta categoría</p>
            <p style={{ color: "var(--text-muted)" }}>Pronto vamos a publicar contenido acá. ¡Volvé en unos minutos!</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-6 gap-y-10 stagger">
            {items.map((a) => <NewsCard key={a.id} article={a} />)}
          </div>
        )}
      </main>
      <Footer />
    </>
  );
}
